<template>
  <div class="page" :style="{ height: fixedHeight + 'px' }">
    <div class="searchBox">
      <el-form>
        <el-row>
          <el-col :span="8">
            <el-form-item>
              <el-input
                style="width: 200px; margin-right: 10px"
                placeholder="请输入关键字"
                v-model="params.keywords"
                @keyup.enter.native="changeSearch"
                clearable
                size="small"
              ></el-input>
              <el-button
                @click="changeSearch"
                icon="el-icon-search"
                type="warning"
                size="small"
                >搜索</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="入库时间" :label-width="'80px'">
              <el-date-picker
                style="width: 250px"
                v-model="dateTime"
                type="daterange"
                range-separator="-"
                value-format="timestamp"
                size="small"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="changeDate"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        
          <el-col :span="2">
            <resetBtn @reset="reset"></resetBtn>
          </el-col>
          <el-col :span="9" style="text-align: right">
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="tabLine">
      <!-- <div :class="tabs == 1?'active':'noactive'" @click="handleTabClick(1)" size="small">采购列表</div> -->
      <div
        class="tabItem"
        :class="[curTabIndex == 0 ? 'active' : '']"
        @click="changeTab(0)"
      >
        全部
      </div>
      <div
        class="tabItem"
        :class="[curTabIndex == 5 ? 'active' : '']"
        @click="changeTab(5)"
      >
        待验收
      </div>
      <div
        class="tabItem"
        :class="[curTabIndex == 1 ? 'active' : '']"
        @click="changeTab(1)"
      >
        调拨入库
      </div>
      <div
        class="tabItem"
        :class="[curTabIndex == 3 ? 'active' : '']"
        @click="changeTab(3)"
      >
        门店销售退货入库
      </div>
      <div
        class="tabItem"
        :class="[curTabIndex == 4 ? 'active' : '']"
        @click="changeTab(4)"
      >
        分拨入库
      </div>
    </div>
    <div class="pageConBox">
      <el-table default-expand-all :data="tableData" style="width: 100%">
        <el-table-column
          label-class-name="lablename"
          label="编号"
          prop="no"
        >
        </el-table-column>
        <el-table-column
          sortable
          label-class-name="lablename"
          label="入库日期"
          prop="inDate"
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.inTime}}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="80"
          label-class-name="lablename"
          :label="curTabIndex == 5 ? '调拨人' : '入库人'"
          prop="inUser.title"
        >
        </el-table-column>
        <el-table-column
          label-class-name="lablename"
          label="来源门店"
          prop="otherShopName"
        >
        </el-table-column>
        <el-table-column
          width="130"
          label-class-name="lablename"
          label="入库类型"
          prop="inOrderType.name"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.inOrderType.title }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="curTabIndex == 5"
          min-width="50px"
          label-class-name="lablename"
          label="备注"
          prop="remark"
        >
       </el-table-column>
        <el-table-column 
          min-width="50px"
          label-class-name="lablename"
          label="状态"
          prop="status"
        >
        <template slot-scope="scope">
            <el-link  type="danger" v-if="scope.row.status == 0">取消</el-link> 
            <el-link v-if="scope.row.status == 1"> 正常</el-link>            
          </template>
        </el-table-column>
        <el-table-column
          v-if="curTabIndex == 5"
          label-class-name="lablename"
          label="验收状态"
          prop="remark"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.orderAcceptStatus == 0"> 未验收</span>
            <span v-if="scope.row.orderAcceptStatus == 1"> 部分验收</span>
            <span v-if="scope.row.orderAcceptStatus == 2"> 全部验收</span>
           
          </template>
        </el-table-column>      
        
        <el-table-column label-class-name="lablename" label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              v-if="curTabIndex == 5 && scope.row.acceptStatus != '2'"
              size="mini"
              type="text"
              @click="
                $router.push({ path: '/rukuNew/rukuAdd?id=' + scope.row.id })
              "
              >验货</el-button
            >
            <el-button size="mini" type="text" @click="see(scope.row.id)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <page
        :page="page.page"
        :total="page.total"
        :pageSize="page.pageSize"
        @change="pageChange"
        style="padding: 20px 0"
      ></page>
    </div>
    <div v-if="drawerSee_state">
      <drawerSee :id="curId" @submit="submit_drawerSee"></drawerSee>
    </div>
  </div>
</template>
<script>
import page from "@/components/page.vue";
import sumGoodsCount from "@/util/bound.js";
import drawerSee from "./drawerSee.vue";
import resetBtn from "../../../components/resetBtn.vue";
export default {
  components: {
    page,
    resetBtn,
    drawerSee,
  },
  data() {
    return {
      fixedHeight: "",
      tableData: [],
      dateTime: [],
      params: {
        inDateStart: "", // 入库查询开始日期
        inDateEnd: "", // 入库查询结束日期
        inOrderType: "", // 入库类型   0：采购入库  1:分拨入库   2:门店调拨      3：门店销售退货入库  4:门店初始化库存
        shopId: this.$store.getters.curShopInfo.shop_id,
        keywords: "",
        acceptStatus: "", 
      },
      dialogVisible: false,
      editDialog: false,
      loading: false,
      dialogDetail: false,
      datadetail: "",
      sumGoodsData: [],
      // 当前tab
      curTabIndex: 0,
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      // 查看
      drawerSee_state: false,
      curId: "",
    };
  },
  created() {
    this.fixedHeight = document.documentElement.clientHeight - 76;
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    // 查看
    see(id) {
      this.drawerSee_state = true;
      this.curId = id;
    },
    submit_drawerSee() {
      this.drawerSee_state = false;
    },

    changeTab(i) {
      this.curTabIndex = i;
      this.params.acceptStatus = ""; 
      if (i === 1) {  //门店调拨入库
        this.params.inOrderType = "2";
      }  else if (i === 3) { //销售退货
        this.params.inOrderType = "3";
      } else if (i === 4) { //分拨入库
        this.params.inOrderType = "0";
      } else if (i === 0) {  //全部
        this.params.inOrderType = "";
      } else if (i === 5) { //待验收
        this.params.inOrderType = "2";
        this.params.acceptStatus = "0,1"; 
      }
      this.page.page = 1;
      this.getTableData();
    },
    reset() {
      this.params.inDateStart = "";
      this.params.inDateEnd = "";
      this.params.keywords = "";
      this.dateTime = [];
      this.page.page = 1;
      this.getTableData();
    },
    changeDate() {
      this.page.page = 1;
      this.params.inDateStart = this.dateTime ? this.dateTime[0] : "";
      this.params.inDateEnd = this.dateTime ? this.dateTime[1] : "";
      this.getTableData();
    },
    changeSearch() {
      this.page.page = 1;
      this.getTableData();
    },
    // 改变分页
    pageChange(num) {
      this.page.page = num;
      this.getTableData();
    },
    getTableData() {
      let params = {
        keywords: this.params.keywords,
        shopId: this.params.shopId,
        inDateStart: this.params.inDateStart,
        inDateEnd: this.params.inDateEnd,
        inOrderType: this.params.inOrderType,
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
        acceptStatus: this.params.acceptStatus,
      };
      this.$http
        .post(process.env.VUE_APP_Url66 + "api/In/list", params)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.page.total = res.data.count;
          }
        });
    },
    add() {
      this.$router.push({
        path: "/cangku/rukuAdd",
      });
    },
    
    editItem(id) {
      this.$router.push({
        path: "/cangku/rukuEdit",
        query: {
          id: id,
        },
      });
    },
    lookDl(id) {
      this.$http
        .get(process.env.VUE_APP_Url66 + "api/Warehouse/InOrder/detail", {
          orderId: id,
        })
        .then((res) => {
          if (res.code == 0) {
            console.log(res);
            this.datadetail = res.data;
            this.datadetail.inOrderFile = JSON.parse(
              this.datadetail.inOrderFile
            );
            this.datadetail.checkOrderFile = JSON.parse(
              this.datadetail.checkOrderFile
            );
            this.datadetail.transfersOrderFile = JSON.parse(
              this.datadetail.transfersOrderFile
            );
            this.sumGoodsData = sumGoodsCount(this.datadetail.inOrderItems);
          }
        });
      this.dialogDetail = true;
    },
    toogleExpand(row) {
      let $table = this.$refs.table;
      this.sumGoodsData.map((item) => {
        if (row.goodsId != item.goodsId) {
          $table.toggleRowExpansion(item, false);
        }
      });
      $table.toggleRowExpansion(row);
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  display: flex;
  flex-direction: column;
  .tabLine {
    margin-top: 12px;
    display: flex;
    .tabItem {
      padding: 0 16px;
      line-height: 36px;
      text-align: center;
      border-right: 1px solid #f2f2f2;
      cursor: pointer;
      font-size: 14px;
      background-color: #fff;
      &.active {
        color: $mainColor;
      }
    }
  }
  .pageConBox {
    border-right: 1px solid #f2f2f2;
    flex: 1;
    min-height: 0px;
  }
}
</style>
